module.exports = __webpack_public_path__ + "img/Chart-pie-alt.1f44e3b5.svg";